import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'arrayFilter',
    standalone: true
})
export class ArrayFilterPipe<T> implements PipeTransform {
    transform(items: T[] | null | undefined, filterPredicate: (item: T) => boolean): T[] {
        if (!items) {
            return [];
        }

        return items.filter(filterPredicate);
    }
}
